import React, { useEffect, useState } from 'react';
import { Form, Field } from 'react-final-form';
import PropType from 'prop-types';
import * as html2canvas from 'html2canvas';
import { useRouteMatch } from 'react-router-dom';

import GenericTextInputField from '../form-fields/GenericTextInputField';
import GenericTextAreaInputField from '../form-fields/GenericTextAreaInputField';

// todo - move reusable css to common place
const buttonCss =
    'disabled:opacity-50 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded float-right';

const ReportIssue = (props) => {
    const [issueImage, setIssueImage] = useState();
    const routeMatch = useRouteMatch();

    const { url } = routeMatch.params;

    useEffect(async () => {
        const canvas = await html2canvas(document.querySelector('#root'));
        setIssueImage(canvas.toDataURL('image/png'));
    }, []);

    const _submit = (urlValue, values) =>
        new Promise((resolve, reject) => {
            props
                .reportIssue(urlValue, values)
                .then((res) => resolve({}))
                .catch((error) => resolve(error));
        });

    return (
        <Form
            onSubmit={(values) => _submit(url, values)}
            render={({
                handleSubmit,
                pristine,
                submitErrors,
                submitting,
                submitSucceeded,
            }) => {
                const submitDisabled =
                    pristine || submitSucceeded || submitting;
                return (
                    <div className="px-8 py-4 border border-gray-200">
                        <form className="text-base" onSubmit={handleSubmit}>
                            <GenericTextInputField
                                name={'email'}
                                label={'Email'}
                                placeholder={'Enter your email address'}
                                required
                                validateAndRequiredEmail
                                dataTestId={'reporter-email'}
                            />

                            <GenericTextInputField
                                name={'subject'}
                                label={'Subject'}
                                placeholder={
                                    'e.g. Not able to move forward with the Application'
                                }
                                required
                                dataTestId={'subject'}
                            />

                            <GenericTextAreaInputField
                                name={'description'}
                                label={'Description'}
                                required
                                dataTestId={'issue-description'}
                            />

                            <Field
                                name={'screenshot'}
                                initialValue={issueImage}
                                render={
                                    () => <div />
                                    // return (<img src={input.value}/>); // uncomment this line to render the image.
                                }
                            />

                            <div className="ml-1 italic">
                                {submitErrors && (
                                    <div
                                        className="text-red-500"
                                        data-testid="submit-failure"
                                    >
                                        Failed to report issue. Please send an
                                        Email to {props.emailLink}.
                                    </div>
                                )}

                                {submitSucceeded && (
                                    <div
                                        className="text-green-600"
                                        data-testid="submit-success"
                                    >
                                        Successfully reported issue.
                                    </div>
                                )}
                            </div>

                            <div className="mt-4">
                                <div className="block float-right font-semibold">
                                    <button
                                        className={buttonCss}
                                        disabled={submitDisabled}
                                        data-testid="submit-issue"
                                    >
                                        Submit
                                    </button>
                                </div>
                                <div className="clear-both" />
                            </div>
                        </form>
                    </div>
                );
            }}
        />
    );
};

ReportIssue.propTypes = {
    reportIssue: PropType.func,
    emailLink: PropType.element,
};

export default ReportIssue;
